import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Badge } from '@mui/material';

const initials = (name) => (name || '?').trim().charAt(0).toUpperCase();

/**
 * OTRIX Play — avatar con punto de presencia (verde de estado) cuando el usuario está "en línea".
 * El anillo del punto usa la superficie de la card para que "recorte" limpio sobre ella.
 *
 * Vive en su propio archivo porque lo comparten el foro, el modal de likers y el perfil del atleta.
 */
function OnlineAvatar({ name = '', photo = null, online = false, size = 40, onClick = null }) {
  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      variant="dot"
      invisible={!online}
      sx={{
        '& .MuiBadge-badge': {
          bgcolor: 'success.main',
          color: 'success.main',
          minWidth: size > 40 ? 12 : 10,
          height: size > 40 ? 12 : 10,
          borderRadius: '50%',
          boxShadow: (theme) => `0 0 0 2px ${theme.palette.surface.raised}`
        }
      }}>
      <Avatar
        src={photo || undefined}
        onClick={onClick}
        sx={{ width: size, height: size, bgcolor: 'gold.soft', color: 'gold.main', flex: 'none', cursor: onClick ? 'pointer' : 'default' }}>
        {initials(name)}
      </Avatar>
    </Badge>
  );
}

OnlineAvatar.propTypes = {
  name: PropTypes.string,
  photo: PropTypes.string,
  online: PropTypes.bool,
  size: PropTypes.number,
  onClick: PropTypes.func
};

export default OnlineAvatar;
